import React from "react";
import { observer } from "mobx-react";

import { AccountStatementFilter } from "../filter";
import { AccountStatementTableSection } from "@features/account-statement/desktop/components/AccountStatementTableSection";

export const AccountStatementBody = observer(function AccountStatementBody() {
	return (
		<>
			<AccountStatementFilter />
			<AccountStatementTableSection />
		</>
	);
});
